import { Component, type ReactNode } from "react";

/**
 * Catches errors thrown while rendering — most importantly the friendly
 * validation error from `loadFactors` when `factors.json` is malformed — and
 * shows the message plainly instead of a blank screen. This is the safety net
 * that lets you edit the data confidently.
 */
export default class ErrorScreen extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-void p-6 text-white">
          <div className="max-w-lg rounded-2xl border border-confidence-low/30 bg-nebula/60 p-6">
            <h1 className="mb-3 font-display text-2xl text-confidence-low">
              Something needs fixing
            </h1>
            <pre className="whitespace-pre-wrap font-mono text-sm leading-relaxed text-white/70">
              {this.state.error.message}
            </pre>
            <p className="mt-4 text-xs text-white/40">
              This usually means <code>src/data/factors.json</code> has an
              issue. Fix it and the app will reload.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
